import { Controller } from "react-hook-form";

import { BaseFieldProps } from "@/constants/field";

import { DisabledArea } from "../DisabledArea/DisabledArea";
import {
  AspectRatio,
  AspectRatioProps,
  NoneSelectedProps,
} from "./AspectRatio";

type ControlledAspectRatioProps = BaseFieldProps & {
  presets?: AspectRatioProps["presets"];
  withLabel?: AspectRatioProps["withLabel"];
} & NoneSelectedProps;

export const ControlledAspectRatio = (props: ControlledAspectRatioProps) => {
  const { fieldName, disabled = false, disabledTooltip = "", ...rest } = props;

  return (
    <DisabledArea disabled={disabled} title={disabledTooltip}>
      <Controller
        name={fieldName}
        render={({ field, fieldState: { error } }) => (
          <AspectRatio
            value={field.value}
            onChange={field.onChange}
            disabled={disabled}
            error={!!error}
            {...rest}
          />
        )}
      />
    </DisabledArea>
  );
};
